import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { isUniqueJuryo } from 'utils/booleanUtil'
import { responseJuryo } from 'utils/requestUtil'

type TableJuryoState = {
  selectList: responseJuryo[] // 選択している条件管理番号を保持
}

const initialState: TableJuryoState = {
  selectList: [], // 選択している条件管理番号を保持
}
export const TableJuryoSlice = createSlice({
  name: 'TableJuryo',
  initialState: initialState,
  reducers: {
    // 全チェック処理 //=========================//
    checkAllJoken: (state, action: PayloadAction<{ isChecked: boolean; jokenList: responseJuryo[] }>) => {
      const payload = action.payload
      const isChecked = payload.isChecked
      if (isChecked) {
        // チェック除去
        state.selectList = []
      } else {
        // チェック付与
        const selectList: responseJuryo[] = []
        payload.jokenList.forEach((r) =>
          selectList.push({
            ...r,
          }),
        )
        state.selectList = selectList
      }
    },
    // チェック処理 //=========================//
    checkJoken: (state, action: PayloadAction<{ isChecked: boolean; checkData: responseJuryo }>) => {
      const payload = action.payload
      const isChecked = payload.isChecked
      const checkData = payload.checkData
      if (isChecked) {
        // チェック除去
        state.selectList = state.selectList.filter((r) => !isUniqueJuryo(r, checkData))
      } else {
        // チェック付与
        state.selectList.push(checkData)
      }
    },
    // チェックリストを初期化する処理 //================================//
    formatCheckSummary: (state) => {
      state.selectList = initialState.selectList
    },
    // 内容確認依頼を変更する処理 //===========================//
    changeNaiyo: (state, action: PayloadAction<responseJuryo>) => {
      const checkShohin = action.payload
      state.selectList = state.selectList.filter((r) => !isUniqueJuryo(r, checkShohin))
      state.selectList.push(checkShohin)
    },
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof TableJuryoState = key as keyof TableJuryoState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  checkAllJoken, // 条件管理番号を全チェックする処理
  checkJoken, // 条件管理番号をチェックする処理
  formatCheckSummary, // サマリチェックリストを初期化する処理
  changeNaiyo, // 否認理由を変更する処理
  format,
} = TableJuryoSlice.actions
export default TableJuryoSlice.reducer
